import { ArrowUpRight, Cpu } from "lucide-react";
import PageHeader from "./PageHeader";
import { useSiteContent } from "../../context/SiteContext";

const STATUS_STYLE = {
  live: "text-neon border-neon/60",
  beta: "text-yellow-300 border-yellow-500/60",
  alpha: "text-orange-300 border-orange-500/60",
  internal: "text-neutral-300 border-neutral-500/60",
  "coming soon": "text-neutral-500 border-neutral-600/60",
};

export default function ProducersSuite() {
  const content = useSiteContent();
  return (
    <div data-testid="page-producers-suite">
      <PageHeader
        code="01"
        label="PRODUCER'S SUITE"
        title="Producer's Suite"
        subtitle="Internal tooling and small focused apps OGTommyP uses to keep the label moving solo. Everything here is built in-house or maintained directly."
      />

      <section>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {content.apps.map((app) => {
              const soon = app.status === "coming soon";
              const Tag = soon ? "div" : "a";
              const linkProps = soon ? {} : { href: app.url, target: "_blank", rel: "noreferrer" };
              return (
                <Tag
                  key={app.id}
                  {...linkProps}
                  data-testid={`app-card-${app.id}`}
                  className={`em-card p-6 flex flex-col gap-6 min-h-[260px] ${soon ? "opacity-50 cursor-default" : ""}`}
                >
                  <div className="flex items-start justify-between">
                    <div
                      className={`label-mono px-2 py-1 border ${
                        STATUS_STYLE[app.status] || STATUS_STYLE.internal
                      }`}
                    >
                      {soon ? "○" : "●"} {app.status}
                    </div>
                    <Cpu size={20} className="text-neutral-500" />
                  </div>

                  <div className="flex-1">
                    <div className="label-mono text-neutral-500">{app.category} · {app.version}</div>
                    <div className="font-display font-bold text-xl mt-2">{app.name}</div>
                    <p className="text-neutral-400 text-sm mt-3 leading-relaxed">
                      {app.description}
                    </p>
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-[#27272A]">
                    <span className="label-mono text-neutral-500">{soon ? "COMING SOON" : "LAUNCH"}</span>
                    {!soon && <ArrowUpRight size={18} className="text-neon" />}
                  </div>
                </Tag>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
